import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database' // ✅ Added Realtime Database

// Firebase configuration
// ✅ Updated to use correct environment variables with proper fallbacks
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyD9NOWP13mCHXRiiFDOqor7bCJu17pR9D4",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "nursing-examm.firebaseapp.com",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://nursing-examm-default-rtdb.firebaseio.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "nursing-examm",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "nursing-examm.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "1069208140781",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:1069208140781:web:9730c6230780503afb05e4",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-1704G97ZLB"
}

// Initialize Firebase
let app = null
let db = null
let storage = null
let auth = null
let database = null // ✅ Realtime Database instance

// Initialize Firebase immediately (synchronous parts)
try {
  console.log('🚀 Starting Firebase initialization...')
  app = initializeApp(firebaseConfig)
  db = getFirestore(app)
  storage = getStorage(app)
  auth = getAuth(app)
  database = getDatabase(app)
  
  console.log('✅ Firebase initialized successfully (basic)')
  console.log('📊 Project ID:', firebaseConfig.projectId)
  console.log('🔥 Firestore:', db ? 'Connected' : 'Not Connected')
  console.log('📁 Storage:', storage ? 'Connected' : 'Not Connected')
  console.log('🔐 Auth:', auth ? 'Connected' : 'Not Connected')
  console.log('🗄️ Realtime DB:', database ? 'Connected' : 'Not Connected')
} catch (error) {
  console.error('❌ Firebase basic initialization error:', error)
  console.error('🔧 Config used:', {
    ...firebaseConfig,
    apiKey: firebaseConfig.apiKey ? '[HIDDEN]' : 'NOT_SET'
  })
  
  // Provide fallback empty objects to prevent app crashes
  db = null
  storage = null
  auth = null
  database = null
}

const initializeFirebase = async () => {
  try {
    console.log('🔧 Configuring advanced Firebase settings...')
    
    if (!app) {
      throw new Error('Firebase app not initialized')
    }
    
    // Configure advanced Firestore settings
    if (db) {
      try {
        // Test Firestore connection
        await enableNetwork(db)
        console.log('✅ Firestore network enabled successfully')
      } catch (networkError) {
        console.warn('⚠️ Firestore network configuration warning:', networkError.message)
      }
    }
    
    console.log('✅ Advanced Firebase configuration completed!')
    return true
  } catch (error) {
    console.error('❌ Advanced Firebase configuration error:', error)
    return false
  }
}

// Initialize Firebase
const initPromise = initializeFirebase()

// Add connection retry logic for advanced features
const getFirestoreInstance = async () => {
  await initPromise // Wait for advanced initialization
  
  if (!db) {
    console.error('❌ Firestore not initialized, retrying...')
    const retrySuccess = await initializeFirebase()
    if (!retrySuccess) {
      throw new Error('Firestore initialization failed after retry')
    }
  }
  
  return db
}

// Export all required Firebase instances
export { app, db, storage, auth, database, getFirestoreInstance }
export default app
